module.exports = __webpack_public_path__ + "img/MWA.ee78ce92.png";